import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "@app/shared/button/button.module";
import { LoadingSpinnerModule } from "@app/shared/spinner/loading-spinner.module";
import { TextInputModule } from "@app/shared/text-input/text-input.module";
import { TranslateModule } from "@ngx-translate/core";
import { LoginRoutingModule } from "./login-routes.module";
import { LoginComponent } from "./login.component";
import { ConfirmModule } from "./confirm/confirm.module";
import { UtilsModule } from "@app/shared/utils/utils-module";
import { MatDialogModule } from "@angular/material/dialog";
import { ErrorBoxModule } from "@app/shared/error-box/error-box.module";
@NgModule({
    declarations: [LoginComponent],
    imports: [CommonModule, LoginRoutingModule, TranslateModule, TextInputModule, ButtonModule, LoadingSpinnerModule, ConfirmModule, UtilsModule, MatDialogModule, ErrorBoxModule],
    exports: [LoginComponent],
})
export class LoginModule {}
